import './style.scss'
import { Button, Modal } from 'antd'
import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import * as Api from '@/api/home'

interface IProps {
  selectId?: number
  open: boolean
  group: any
  onCheck: (p: any) => void
  onCancel: () => void
}

const PhotoLibrary: FC<IProps> = (props) => {
  const { t } = useTranslation(['avatar', 'system'])
  const { open, group, onCheck, onCancel, selectId } = props
  const [photos, setPhotos] = useState<any[]>()

  useEffect(() => {
    if (open) {
      getPhotoLibrary()
    }
  }, [open])

  const getPhotoLibrary = async () => {
    const res = await Api.getDigitalPhotosByGroup(group.id as number)
    setPhotos(res?.list || [])
  }

  return (
    <Modal
      title={t('avatar.photo_materials')}
      open={!!open}
      width={900}
      footer={null}
      onCancel={onCancel}
      className="commom-modal photo-library-modal"
    >
      <div className="photo-library">
        {photos && (
          <>
            {photos.length ? (
              <>
                <div className="photo-library-list">
                  {photos.map((p) => (
                    <div key={p.id} className={`list-item ${selectId === p.id ? 'actived' : ''}`}>
                      <div className="img-box">
                        <img src={p.url} />

                        <div className="mask"></div>

                        <Button
                          className="select-btn"
                          type="primary"
                          onClick={() => {
                            onCheck(p)
                            onCancel()
                          }}
                        >
                          {t('system.select')}
                        </Button>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <div className="photo-empty">{t('avatar.no_photo_materials')}</div>
            )}
          </>
        )}
      </div>
    </Modal>
  )
}

export default PhotoLibrary
